import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack } from '@fluentui/react/lib/Stack';
import {
  Subtitle1,
} from '@fluentui/react-components';
import { PerformanceCard } from './performance-card/performance-card';

const dataVizColors = {
  conversion: '#CA5010',
  search: '#9373C0',
  visit: '#E3008C',
};

const tokens = {
  childrenGap: 15,
};

export const ExperimentOverviewSection = ({
  conversionData,
  measurementTypes,
  searchData,
  visitData,
}) => {
  const i18n = useContext(I18nContext);
  const sectionTitle = i18n.getString(_TL_('Overview'));
  const searchTitle = i18n.getString(_TL_('Search lift'));
  const searchSubtitle = i18n.getString(_TL_('Brand search rate'));
  const visitTitle = i18n.getString(_TL_('Visit lift'));
  const visitSubtitle = i18n.getString(_TL_('Website visitation rate'));
  const conversionTitle = i18n.getString(_TL_('Conversion lift'));
  const conversionSubtitle = i18n.getString(_TL_('Conversion rate'));
  const { useConversionLift, useSearchLift, useVisitLift } = measurementTypes;

  return (
    <>
      <Subtitle1>{sectionTitle}</Subtitle1>
      <Stack horizontal tokens={tokens}>
        {useSearchLift && (
          <PerformanceCard
            color={dataVizColors.search}
            liftHelpTopic="pop_BA_Experiments_Awareness"
            subtitle={searchSubtitle}
            title={searchTitle}
            {...searchData}
          />
        )}
        {useVisitLift && (
          <PerformanceCard
            color={dataVizColors.visit}
            liftHelpTopic="pop_BA_Experiments_Consideration"
            subtitle={visitSubtitle}
            title={visitTitle}
            {...visitData}
          />
        )}
        {useConversionLift && (
          <PerformanceCard
            color={dataVizColors.conversion}
            liftHelpTopic="pop_BA_Experiments_Conversions"
            subtitle={conversionSubtitle}
            title={conversionTitle}
            {...conversionData}
          />
        )}
      </Stack>
    </>
  );
};

ExperimentOverviewSection.propTypes = {
  conversionData: PropTypes.shape({
    confidence: PropTypes.string.isRequired,
    control: PropTypes.number.isRequired,
    lift: PropTypes.number.isRequired,
    treatment: PropTypes.number.isRequired,
  }).isRequired,
  measurementTypes: PropTypes.shape({
    useConversionLift: PropTypes.bool.isRequired,
    useSearchLift: PropTypes.bool.isRequired,
    useVisitLift: PropTypes.bool.isRequired,
  }).isRequired,
  searchData: PropTypes.shape({
    confidence: PropTypes.string.isRequired,
    control: PropTypes.number.isRequired,
    lift: PropTypes.number.isRequired,
    treatment: PropTypes.number.isRequired,
  }).isRequired,
  visitData: PropTypes.shape({
    confidence: PropTypes.string.isRequired,
    control: PropTypes.number.isRequired,
    lift: PropTypes.number.isRequired,
    treatment: PropTypes.number.isRequired,
  }).isRequired,
};
